module.exports = __webpack_public_path__ + "static/media/organization-new-menu-icon.29e0cd9b.svg";